import { Modal } from 'react-bootstrap';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SelectBasesWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BasesContainer = styled.div`
  max-height: 500px;
  overflow-y: auto;
  padding: 0 8px 0 0;
  gap: 12px;
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #e9e9e9;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #0b29fb;
    border-radius: 6px;
    border: 2px solid #e9e9e9;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #0b29fb;
    border-radius: 6px;
  }
`;

export const ScheduleFormWrapper = styled.div`
  width: 68%;
  padding: 0 16px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0;
  }
`;

export const ScheduleFormHeader = styled.div``;

export const ScheduleFormInfosWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const QuestionRefuel = styled.span`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const QuestionComplement = styled.span`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #3d3d3d;
`;

export const CalendarWrapper = styled.div`
  margin-top: 24px;
`;

export const RouteInfoWrapper = styled.div`
  margin-top: 24px;
  width: 100%;
`;

export const RouteInfoImage = styled.img`
  width: 100%;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e9e9e9;
  margin: 24px 0;
`;

type RefuelDateInformationWrapperProps = {
  isError: boolean;
};

export const RefuelDateInformationWrapper = styled.div<RefuelDateInformationWrapperProps>`
  background: #94f7ff36;
  border: 1px solid #0b29fb;
  border-radius: 8px;
  padding: 12px 16px;

  ${({ isError }) =>
    isError &&
    css`
      border: 1px solid #e74141;
    `}
`;

export const LabelRefuelDescription = styled.span`
  margin-top: 12px;
  display: inline-flex;
  color: #000;
  font-size: 18px;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 15px;
  }
`;

export const ContainerTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const RefuelDataLabel = styled.span`
  display: inline-flex;
  font-family: 'Mangueira Bold', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #3d3d3d;

  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 15px;
  }
`;

export const RefuelDataValue = styled(RefuelDataLabel)`
  font-family: 'Mangueira Bold', sans-serif;
  font-weight: 700;
  color: #0b29fb;

  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 15px;
  }
`;

export const ModalStyled = styled(Modal)`
  & .modal-dialog {
    max-width: 550px;
    width: 100%;
  }

  & .modal-content {
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 25px 40px;
    width: 100%;

    @media (max-width: 768px) {
      padding: 25px;
    }
  }
`;
